export const isNumber = x => x !== null && typeof x !== 'undefined' && !Number.isNaN(x);
